import React, { useEffect, useState } from 'react'
import { authedAxios } from '../../utils'
import useCustomerContacts from '../../hooks/api/useCustomerContacts'
import { getDateForInputFieldFromTimestamp } from '../../utils/date'
import useAlert from '../../hooks/useAlert'
import { TASK_STATUS_TYPES, TASK_TYPES } from '../../constants'
import TaskOutcome from '../../common/TaskOutcome'

const TaskModalWrapper = (props) => {
  const {
    Component,
    contact: contactProp,
    onSave: onSaveProp,
    task,
    customer,
    onClose,
  } = props

  const [note, setNote] = useState('')
  const [date, setDate] = useState(new Date().toLocaleDateString('sv'))
  const [error, setError] = useState(false)

  const [savedTask, setSavedTask] = useState(null)

  const [outcomeMode, setOutcomeMode] = useState(false)

  const { createGenericErrorAlert } = useAlert()

  const isEditing = !!task

  const customerId = task?.customerId || customer?.id

  const { customerContacts } = useCustomerContacts(task?.customerId)
  const getContact = () => {
    return contactProp || !task
      ? contactProp
      : customerContacts.find((cc) => cc.id === task.customerContactId)
  }

  const contact = getContact()

  const onSave = (taskTypeId, statusTypeId) => {
    if (isEditing) {
      return saveTask(statusTypeId)
    }
    return createTask(taskTypeId, statusTypeId)
  }

  const createTask = (taskTypeId, statusTypeId) => {
    const body = {
      note,
      taskTypeId,
      statusTypeId: statusTypeId || task.statusTypeId,
      customerId,
      date: new Date(date),
      customerContactId: contact?.id,
    }

    return authedAxios
      .post('/api/task', body)
      .then((res) => {
        setSavedTask(res.data.task)
        if (statusTypeId === TASK_STATUS_TYPES.DONE) return setOutcomeMode(true)
        if (onSaveProp) onSaveProp(res.data.task)
      })
      .catch((e) => {
        createGenericErrorAlert()
        setError(true)
      })
  }

  const saveTask = (statusTypeId) => {
    const body = {
      ...task,
      note,
      customerId,
      date: new Date(date),
      statusTypeId: statusTypeId || task.statusTypeId,
      customerContactId: contact?.id,
    }

    return authedAxios
      .put(`/api/task/${task.id}`, body)
      .then((res) => {
        if (statusTypeId === TASK_STATUS_TYPES.DONE) return setOutcomeMode(true)

        if (onSaveProp) onSaveProp(res.data.task)
      })
      .catch((e) => {
        setError(true)
      })
  }

  const today = new Date().toLocaleDateString('sv')

  useEffect(() => {
    setNote(task?.note || '')
    setDate(task?.date ? getDateForInputFieldFromTimestamp(task.date) : today)
  }, [task])

  return (
    <Component
      {...props}
      contact={contact}
      customer={customer}
      onSave={onSave}
      note={note}
      date={date}
      error={error}
      setNote={setNote}
      setDate={setDate}
      setError={setError}
      today={today}
      isEditing={isEditing}
      onCloseModal={onClose}
      outcomeMode={outcomeMode}
      setOutcomeMode={setOutcomeMode}
      onSaveProp={onSaveProp}
      task={task || savedTask}
    ></Component>
  )
}

export default TaskModalWrapper
